export const SET_ACCESS_TOKEN = 'AUTH/SET_ACCESS_TOKEN';
export const SET_REFRESH_TOKEN = 'AUTH/SET_REFRESH_TOKEN';
export const SET_USERNAME = 'AUTH/SET_USERNAME';

export const setAccessToken = data => ({
    type: SET_ACCESS_TOKEN,
    data
});
export const setRefreshToken = data => ({
    type: SET_REFRESH_TOKEN,
    data
});
export const setUsername = data => ({
    type: SET_USERNAME,
    data
});